import { z } from "zod";

// ── Sidebar badge (#748): how many client imports still wait for Invyo ──

export const PendingClientImportsCountResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({ count: z.number().int() }),
});
export type PendingClientImportsCountResponse = z.infer<typeof PendingClientImportsCountResponseSchema>;
